/** Auto-generated from landing-i18n-remaining-source-ja.md */
export const landingRemainingJa = {
  aiToolsIndex: {
    seo_content: {
      steps: {
        1: {
          title: 'コンテンツを入力する',
          description: 'キャプション、商品説明、イベント詳細、マーケティングコピーを貼り付けます。',
        },
        2: {
          title: 'AI が構造化されたレイアウトを生成',
          description:
            'Veeso がコンテンツをバランスの取れた、読みやすい、実用レベルのデザインレイアウトに自動構成します。',
        },
        3: {
          title: '自由に編集してエクスポート',
          description:
            'テキスト、画像、レイアウトブロック、スタイルを調整し、SNS、EC プラットフォーム、印刷用にエクスポートできます。',
        },
        title: 'デザインを生成する簡単な 3 ステップ',
      },
      audience: {
        title: 'Veeso AI は誰のためのツール？',
        learn_more: '詳しく見る',
        marketers: {
          title: 'マーケター向け',
          description: '数分で魅力的なマーケティングコンテンツを作成。デザインスキルは不要です。',
        },
        hr: {
          title: '人事担当者向け',
          description:
            '魅力的な人事コンテンツ、採用資料、社内コミュニケーションをデザインできます。',
        },
        founders: {
          title: '創業者向け',
          description:
            'デザインチームなしでブランドを構築。スタートアップのためのプロフェッショナルなコンテンツを作成できます。',
        },
        creators: {
          title: 'クリエイター向け',
          description:
            '際立つコンテンツを作成。YouTube サムネイル、Instagram 投稿などに対応します。',
        },
        startups: {
          title: 'スタートアップ向け',
          description:
            'チームを拡大せずにデザインをスケール。スタートアップのスピードでプロフェッショナルな資料を作成できます。',
        },
      },
      faq: {
        title: 'よくある質問',
        items: [
          {
            question: 'Veeso AI とは何ですか？',
            answerParagraph1:
              'デザインリソースが限られ、納期に追われる中小企業のオーナー、マーケター、オペレーション担当者、創業者にとって、プロフェッショナルなビジュアルの制作は時間とコストがかかります。',
            answerParagraph2:
              'Veeso はコンテンツファーストのデザインツールで、コピーライティングをワンクリック・1 分で、デザインスキル不要で洗練されたビジュアルに変換します。',
            answerParagraph3:
              'コンテンツやテキストを貼り付けるだけで、以下のような美しいデザインを瞬時に生成できます：',
            products: [
              'SNS 投稿',
              'ポスター',
              'プレゼンテーション',
              'カルーセル',
              '複数ページのパンフレット',
              '長文コンテンツ',
              'レストランメニュー',
              '招待状',
              'ロールアップバナー',
              'チラシ',
              'アルバムカバー',
            ],
          },
          {
            question: 'Veeso は無料で使えますか？',
            answer:
              'はい。Veeso は AI デザインツールへの無料アクセスを提供しており、初期費用なしでレイアウトを生成・編集できます。すぐに作成を開始でき、さまざまなデザインジェネレーターをひとつの場所で試せます。',
          },
          {
            question: 'Veeso は他の AI デザインツールとどう違うのですか？',
            answerParagraph1:
              'ほとんどの AI デザインツールは、修正が難しい平面的な画像を生成します。',
            answerParagraph2:
              'Veeso は、編集可能なテキスト、セクション、視覚的階層を備えた構造化レイアウトを生成します。静的な結果に縛られることなく、実用的なデザインファイルを調整・修正・エクスポートできます。',
            answerParagraph3: '単なる視覚的実験ではなく、実際の公開を目的として設計されています。',
          },
          {
            question: 'Veeso が生成したデザインは編集できますか？',
            answerParagraph1:
              'はい。Veeso が生成するすべてのデザインは完全に編集可能です。以下のことができます：',
            answerParagraph2: 'これにより、生成後も完全なコントロールが可能になります。',
            listItems: [
              'テキスト内容を修正する',
              'レイアウトブロックを並べ替える',
              '画像を差し替える',
              '余白や構造を調整する',
            ],
          },
          {
            question: 'プロンプトを書く必要はありますか？',
            answerParagraph1:
              'いいえ。Veeso はプロンプトエンジニアリングではなく、コンテンツ入力を中心に設計されています。',
            answerParagraph2:
              'キャプション、商品説明、イベント詳細を貼り付けるだけです。AI が自動的に構造化されたレイアウトに整えます。複雑なプロンプトは不要です。',
          },
          {
            question: 'Veeso はテンプレートを使うより優れていますか？',
            answerParagraph1: 'テンプレートは手動での編集と調整が必要な固定レイアウトです。',
            answerParagraph2:
              'Veeso は、あなたの具体的なコンテンツに基づいてレイアウトを動的に生成します。構造がテキストに適応するため、静的なテンプレートから始めるよりも高速で柔軟なプロセスを実現します。',
          },
          {
            question: 'Veeso は Canva の代替になりますか？',
            answerParagraph1:
              'はい。ただし、Veeso は単なるテンプレートベースのエディタではありません。コンテンツを編集可能なデザインファイルに直接変換する、AI 生成の構造化レイアウトに重点を置いています。',
            answerParagraph2:
              'ゼロから始める必要をなくし、制作プロセスを高速化することで、従来のデザインツールを補完できます。',
          },
          {
            question: 'Veeso はビジネス向けに適していますか？',
            answer:
              'はい。Veeso は、実用レベルのビジュアルコンテンツを素早く必要とするクリエイター、マーケター、EC 販売者、小規模ビジネス向けに設計されています。',
          },
        ],
      },
    },
  },
  articleDetail: {
    breadcrumb: {
      home: 'ホーム',
    },
    toc: {
      title: '目次',
    },
    meta: {
      min_read: '{{count}} 分で読める',
      last_updated: '最終更新:',
      author: 'Veeso チーム',
    },
    faq: {
      title: 'よくある質問',
      subtitle: 'デザイン思考について知っておくべきこと',
    },
    share: {
      twitter: 'X で共有',
      linkedin: 'LinkedIn で共有',
      facebook: 'Facebook で共有',
      discord: 'Discord に参加',
      aria_twitter: 'X（Twitter）で共有',
      aria_linkedin: 'LinkedIn で共有',
      aria_facebook: 'Facebook で共有',
      aria_discord: 'Discord に参加',
    },
    recommended: {
      title: 'おすすめ記事',
      see_all: 'すべて見る',
    },
    cta: {
      title_line1: '今すぐ',
      title_line2: 'Veeso AI でデザインを始めましょう。',
      signup: '無料ではじめる',
    },
    seo_description_fallback: 'Veeso ブログでもっと読む',
  },
  blog: {
    index: {
      hero: {
        title: '学ぶ＆ブログ',
        subtitle: '知見、チュートリアル、ベストプラクティスをご紹介します。',
      },
      seo: {
        description:
          'AI デザインに関する知見、チュートリアル、ベストプラクティスをご紹介します。Veeso AI で魅力的なビジュアルを作成する方法を学びましょう。',
        page_title: '{{title}} - {{page}} ページ | Veeso',
      },
      faq: {
        title: 'よくある質問',
      },
      pagination: {
        prev: '← 前へ',
        next: '次へ →',
        prev_aria: '前のページへ',
        next_aria: '次のページへ',
      },
      author_alt_fallback: '著者',
      empty_state: 'まだブログ記事はありません。後ほど再度ご確認ください！',
      min_read: '{{count}} 分で読める',
      showing_posts: '{{total}} 件中 {{start}}–{{end}} 件を表示',
    },
    detail: {
      breadcrumb: {
        blog: '学ぶ＆ブログ',
      },
    },
  },
  spotlight: {
    index: {
      hero: {
        subtitle_fallback:
          'AI のリリース情報、比較、実践的なガイドを、まだ意味のあるうちにお届けします。',
      },
      min_read: '{{count}} 分で読める',
      showing_posts: '{{total}} 件中 {{start}}–{{end}} 件を表示',
      author_alt_fallback: '著者',
      image_alt_fallback: 'スポットライト記事の画像',
      page_aria: '{{page}} ページへ移動',
      seo: {
        page_title: '{{title}} - {{page}} ページ | Veeso',
        description_fallback:
          'AI プロダクトのリリース、モデル比較、実践的なガイドをタイムリーにお届け。スクリーンショットだけでなく、実際にビジュアルを公開するチーム向けに執筆されています。',
      },
      faq: {
        title_fallback: 'よくある質問',
      },
      pagination: {
        prev: '← 前へ',
        next: '次へ →',
        prev_aria: '前のページへ',
        next_aria: '次のページへ',
      },
    },
    detail: {
      breadcrumb: {
        spotlight: 'スポットライト',
      },
      seo_description_fallback: 'Veeso Spotlight でもっと読む',
      image_alt_fallback: '記事画像',
      video_title_fallback: 'YouTube 動画',
    },
  },
  aiToolsDetail: {
    breadcrumb: {
      tools: 'AI デザインツール',
    },
    fallback: {
      title: 'AI デザインツール',
    },
    generation_methods: {
      title_prefix: '3 つの生成方法',
      product_type_fallback: 'Facebook 投稿',
      section_product_fallback: 'Amazon A+ コンテンツ',
    },
    choose_reasons: {
      cta: '無料で試す',
    },
    use_cases: {
      title_fallback: 'Veeso AI で高コンバージョンのコンテンツ構成を作成',
    },
    testimonials: {
      title_fallback: '{{audienceType}} が Veeso AI を選ぶ理由',
      audience_fallback: 'Amazon セラー',
    },
    how_to: {
      title_fallback: '高コンバージョンの {{productType}} を作成する方法',
      product_type_fallback: 'Amazon A+ コンテンツ',
    },
    faq: {
      title: 'よくある質問',
    },
    cta: {
      image_alt: '画像だけでなく、編集可能なデザインファイルを作成',
    },
    hero: {
      product_type_fallback: 'Amazon 商品',
      design: 'デザイン',
      designing: 'デザイン中...',
    },
    loading: 'ツールを読み込み中...',
    explore_more: 'AI グラフィックデザインのユースケースをもっと見る',
  },
  solutions: {
    slug: {
      'for-marketers': {
        title: 'マーケター向け Veeso',
        subtitle: '数分で魅力的なマーケティングコンテンツを作成',
        description:
          'マーケティングのアイデアを美しいビジュアルに変えましょう。デザインスキルは不要です。',
        heroTitle: 'キャンペーンを素早く展開し、コンバージョン率を向上',
        heroSubtitle:
          'マーケティングブリーフを数分で実用レベルのビジュアルに変換します。デザイナーを待ったり、ブランドの一貫性を妥協したりすることなく、コンバージョンを生む SNS 広告、メール画像、ランディングページ、プレゼンテーションを作成できます。',
        ctaText: '無料ではじめる',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso',
          description:
            'Veeso AI で数分で魅力的なマーケティングビジュアルを作成。デザインスキル不要。マーケティングチームに最適です。',
        },
        features: [
          {
            title: 'キャンペーン即対応のビジュアル',
            description:
              'キャンペーンの目標に沿った広告クリエイティブ、SNS 投稿、メールヘッダー、ランディングページ画像を生成します。すべてのデザインがエンゲージメントとコンバージョンに最適化されています。',
          },
          {
            title: '大規模でもブランドの一貫性を維持',
            description:
              'すべてのマーケティング素材でブランドガイドラインを自動的に維持します。一貫した色、フォント、ビジュアルスタイルにより、どこでもプロフェッショナルなブランドプレゼンスを確保できます。',
          },
          {
            title: '複数フォーマット出力',
            description:
              'Instagram ストーリー、LinkedIn 投稿、メールヘッダー、プレゼンテーションスライドなど、すべてのプラットフォーム向けのデザインを同時に作成します。1 つのコンテンツ入力から、公開準備の整った複数フォーマットを出力します。',
          },
          {
            title: 'A/B テストを簡単に',
            description:
              'オーディエンスに響くものをテストするため、複数のデザインバリエーションを素早く生成します。高速にイテレートし、コンバージョン率を最適化、勝ちパターンのクリエイティブをスケールさせましょう。',
          },
        ],
        faqItems: [
          {
            question: 'Veeso でキャンペーンの A/B テストバリエーションを作成できますか？',
            answer:
              'はい！ Veeso では同じコンテンツから複数のデザインバリエーションを簡単に生成できます。プロンプトを修正したりデザイン設定を調整したりするだけで、異なるビジュアルスタイル、レイアウト、配色を作成できます。これにより、オーディエンスに最も響くものを素早くテストし、コンバージョン率を最適化できます。',
          },
          {
            question:
              'Veeso はすべてのマーケティング素材でブランドの一貫性をどのように確保していますか？',
            answer:
              'Veeso ではブランドカラー、フォント、ロゴを設定できるブランドキットをサポートしています。一度設定すれば、生成されるすべてのデザインに自動でブランドガイドラインが適用されます。これにより、SNS 投稿、メール画像、プレゼンテーション、その他マーケティング素材で一貫したビジュアルアイデンティティを手動チェックなしで維持できます。',
          },
          {
            question: '複数の SNS プラットフォーム向けのデザインを一度に作成できますか？',
            answer:
              'はい！ Veeso は同じコンテンツから異なるプラットフォームに最適化されたデザインを生成できます。Instagram 投稿、LinkedIn 画像、Twitter ヘッダー、メールヘッダーを同時に作成できます。各出力はそれぞれのプラットフォーム要件に合わせてフォーマットされており、手動でのリサイズや再フォーマットの時間を節約できます。',
          },
          {
            question: 'キャンペーンブリーフから公開までどのくらい速くできますか？',
            answer:
              'Veeso なら、マーケティングブリーフを数分で実用レベルのビジュアルに変換できます。キャンペーンコピーを貼り付け、希望するフォーマットを選択するだけで、Veeso が洗練されたデザインを生成します。簡単な編集と承認のあと、すぐにエクスポート・公開できます。デザイナーを待つことも長い修正サイクルもありません。',
          },
          {
            question:
              'Veeso はマーケティング資料用のプレゼンテーションスライド作成に対応していますか？',
            answer:
              'もちろんです！ Veeso はコンテンツからプレゼンテーションスライドを作成することに優れています。ピッチデック、キャンペーン提案、四半期レポートなど、Veeso がコンテンツを適切な階層、ビジュアル、フォーマットを備えたプロフェッショナルなスライドに自動構成します。PowerPoint または PDF 形式に直接エクスポートできます。',
          },
          {
            question: 'Veeso でメールマーケティング用の画像を作成できますか？',
            answer:
              'はい、Veeso はメールマーケティングに最適です。メールクライアントに最適化されたメールヘッダー、バナー画像、インラインビジュアルを作成できます。デザインはさまざまなメールプラットフォームやデバイスで適切に表示されるよう自動的にフォーマットされ、キャンペーンがどこでもプロフェッショナルに見えるよう保証します。',
          },
          {
            question: 'Veeso はランディングページのデザインにどのように役立ちますか？',
            answer:
              'Veeso はランディングページのコピーを完成されたビジュアルレイアウトに変換できます。見出し、バリュープロポジション、機能、CTA テキストを入力するだけで、構造化された、コンバージョン最適化されたデザインが作成されます。デザインをエクスポートしたり、Web 開発チームの参考資料として使用したりできます。',
          },
          {
            question: '生成後にデザインを編集して、ニーズに正確に合わせることはできますか？',
            answer:
              'はい！ Veeso が生成するすべてのデザインは完全に編集可能です。テキストの調整、色の変更、要素のリサイズ、画像の差し替え、レイアウトの修正をエディタ内で直接行えます。これにより、キャンペーン要件に完璧に合うまでデザインを微調整する完全なコントロールが得られます。',
          },
          {
            question: 'マーケティングデザインはどのファイル形式でエクスポートできますか？',
            answer:
              'Veeso は PNG、JPG、PDF、PPT、HTML など複数のエクスポート形式をサポートしています。無料プランのユーザーは透かし付きで標準フォーマットにエクスポートでき、有料プランでは透かしなしの HD エクスポートが利用可能です。この柔軟性により、マーケティング素材があらゆるプラットフォームやユースケースに対応できます。',
          },
          {
            question:
              'マーケティングキャンペーンでデザイナーを雇うのと Veeso はどう比較できますか？',
            answer:
              'Veeso は従来のデザインワークフローでは実現できないスピードとコストパフォーマンスを提供します。デザイナーが数時間から数日かかり、複数の修正サイクルが必要なところを、Veeso は数分でプロフェッショナルなデザインを生成します。完全なクリエイティブコントロールを維持し、即座にイテレートし、デザイン予算を増やさずにビジュアルコンテンツの制作をスケールできます。納期に追われ、デザインリソースが限られたマーケティングチームに最適です。',
          },
        ],
      },
      'for-human-resource': {
        title: '人事担当者向け Veeso',
        subtitle: '魅力的な人事コンテンツを簡単にデザイン',
        description:
          '採用資料、社内コミュニケーション、従業員エンゲージメント用のビジュアルを簡単に作成できます。',
        heroTitle: '優秀人材をより素早く惹きつけ、従業員エンゲージメントを向上',
        heroSubtitle:
          '際立つ魅力的な求人投稿、読まれるプロフェッショナルな社内コミュニケーション、士気を高めるお祝いグラフィックを、デザインスキルや外部代理店なしで作成できます。',
        ctaText: '無料ではじめる',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso',
          description:
            'Veeso AI で魅力的な人事コンテンツ、採用資料、社内コミュニケーションを作成できます。',
        },
        features: [
          {
            title: 'コンバージョンを生む採用活動',
            description:
              '候補者の注目を集める求人投稿や採用バナーをデザインします。プロフェッショナルなビジュアルにより、混雑した求人サイトや SNS フィードであなたの募集が際立ち、より質の高い応募者を引き寄せます。',
          },
          {
            title: '社員を引き込む社内コミュニケーション',
            description:
              '社内発表、ポリシー更新、ニュースレターを視覚的に魅力的なコンテンツに変換します。よくデザインされた社内コミュニケーションは閲覧率を向上させ、重要な情報をチームに確実に届けます。',
          },
          {
            title: '特別感のある従業員表彰',
            description:
              'お祝いグラフィック、マイルストーン発表、表彰投稿を作成し、従業員に大切にされていると感じてもらえます。プロフェッショナルなビジュアルが表彰プログラムのインパクトを増幅します。',
          },
          {
            title: '印象的なオンボーディング資料',
            description:
              'ウェルカムパッケージ、トレーニング資料、オリエンテーション用グラフィックをデザインし、新入社員に入社を心から喜んでもらえます。プロフェッショナルなオンボーディングビジュアルが初日から適切な雰囲気を作り出します。',
          },
        ],
        faqItems: [
          {
            question: 'Veeso でより優秀な候補者を惹きつける求人投稿を作成できますか？',
            answer:
              'もちろんです！ Veeso は職務記述書を視覚的に魅力的な採用画像に変換します。よくデザインされた求人投稿は LinkedIn、求人サイト、SNS で際立ち、より適格な候補者を惹きつけます。複数のバリエーションを作成して、職種ごとにどのデザインが最も効果的かをテストできます。',
          },
          {
            question: '従業員表彰やお祝いに Veeso をどう活用できますか？',
            answer:
              'Veeso は表彰グラフィック、記念日のお知らせ、昇進のお祝い、チームの成果投稿の作成に最適です。従業員の名前、成果の詳細、特定のメッセージを入力するだけで、Veeso が特別感とシェアしたくなる気持ちを引き出すプロフェッショナルなグラフィックを生成します。',
          },
          {
            question: 'Veeso で社内ニュースレターや社内アップデートを作成できますか？',
            answer:
              'はい！ Veeso は社内コミュニケーションを魅力的なビジュアルコンテンツに変換することに優れています。従業員が実際に読みたくなるニュースレター、ポリシー発表、会社のアップデート、チームコミュニケーションを作成できます。視覚的階層とプロフェッショナルなデザインが情報の定着率とエンゲージメントを向上させます。',
          },
          {
            question: 'Veeso はオンボーディング資料にどのように役立ちますか？',
            answer:
              'Veeso はウェルカムパッケージ、オリエンテーションスライド、トレーニング資料、オンボーディング用グラフィックを作成し、新入社員に歓迎され、情報を得ていると感じてもらえます。プロフェッショナルなビジュアルがポジティブな第一印象を作り、新入社員が会社の文化やプロセスをより効果的に理解する助けになります。',
          },
          {
            question: 'すべての人事資料で会社のブランディングを維持できますか？',
            answer:
              'はい！ Veeso のブランドキット機能により、すべての人事資料で一貫したビジュアルアイデンティティを維持できます。会社の色、フォント、ロゴを一度設定すれば、生成されるすべてのデザインに自動的にブランドガイドラインが適用されます。これにより、採用、社内コミュニケーション、従業員エンゲージメントの素材全体で一貫性のあるプロフェッショナルな見た目を実現できます。',
          },
          {
            question: '急な募集のための採用グラフィックをどのくらい速く作成できますか？',
            answer:
              'Veeso なら、職務記述書から公開可能な採用グラフィックまで数分で完了します。求人情報を貼り付け、好みのスタイルを選択するだけで、LinkedIn、求人サイト、SNS 向けの複数フォーマットオプションを生成します。デザイナーや代理店を待つ必要はありません。',
          },
          {
            question: '従業員イベントやチームビルディング用の資料を作成できますか？',
            answer:
              'もちろんです！ Veeso でイベント招待状、チームビルディングのお知らせ、ワークショップ用グラフィック、お祝い投稿を作成できます。プロフェッショナルなビジュアルはイベント参加率を上げ、チーム活動をより魅力的かつ整然としたものにします。',
          },
          {
            question: 'Veeso は人事会議用のプレゼンテーションスライド作成に対応していますか？',
            answer:
              'はい！ Veeso は人事会議のコンテンツをプロフェッショナルなプレゼンテーションスライドに変換できます。四半期レビュー、ポリシー更新、トレーニングセッションなど、Veeso がコンテンツを聴衆を引きつけ続ける明確で視覚的に魅力的なスライドに構成します。',
          },
          {
            question:
              'ダイバーシティ＆インクルージョンのコミュニケーションに Veeso はどう役立ちますか？',
            answer:
              'Veeso は D&I イニシアチブ、啓発キャンペーン、各種記念月のための、プロフェッショナルで包摂的なビジュアルの作成をサポートします。よくデザインされた資料により、ダイバーシティ＆インクルージョンのメッセージがすべてのチャネルで効果的かつ敬意を持って伝わります。',
          },
          {
            question:
              'リモートまたはハイブリッドチーム向けのコミュニケーション資料を作成できますか？',
            answer:
              'はい！ Veeso はデジタルコミュニケーションチャネルで効果的に機能するビジュアル作成に最適です。Slack のお知らせ、メールアップデート、バーチャル会議の背景、リモートチームのエンゲージメント向けに最適化されたグラフィックをデザインし、距離を越えてつながりと文化を維持できます。',
          },
        ],
      },
      'for-founders': {
        title: '創業者向け Veeso',
        subtitle: 'デザインチームなしでブランドを構築',
        description:
          'あなたのビジョンを現実に。デザイナーを雇うことなく、スタートアップのためのプロフェッショナルなコンテンツを作成できます。',
        heroTitle: 'より速くローンチし、より多く資金調達し、ブランドを構築',
        heroSubtitle:
          '投資家向けピッチデック、プロフェッショナルな SNS コンテンツ、一貫したブランドビジュアルを、デザイナーを雇ったり予算を圧迫したりすることなく作成できます。プロダクト開発に集中する一方、ビジュアルアイデンティティは Veeso にお任せください。',
        ctaText: '構築をはじめる',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso',
          description:
            'デザインチームなしでスタートアップのためのプロフェッショナルなコンテンツを作成。ブランド、ピッチデック、SNS でのプレゼンスを構築できます。',
        },
        features: [
          {
            title: '投資家向けピッチデック',
            description:
              'スタートアップのストーリーを、投資家に印象を与える魅力的なピッチデックスライドに変換します。データビジュアライゼーション、プロダクトショーケース、市場分析グラフィックを作成し、ビジョンを明確かつプロフェッショナルに伝えられます。',
          },
          {
            title: '初日からのブランドアイデンティティ',
            description:
              'ウェブサイト、SNS、プレゼンテーション、マーケティング素材など、すべてのタッチポイントで一貫したビジュアルアイデンティティを確立します。デザイン代理店を雇うコストなしにブランド認知を構築できます。',
          },
          {
            title: 'プロダクトローンチ資料',
            description:
              'ローンチ告知、プロダクトのスクリーンショット、機能ハイライト、デモビジュアルを作成し、プロダクトをプロフェッショナルに紹介します。ローンチを記憶に残る、シェアしたくなるものにできます。',
          },
          {
            title: '資金調達用ビジュアル',
            description:
              '投資家アップデート、マイルストーン発表、成長グラフィックをデザインし、ステークホルダーを引きつけ続けます。プロフェッショナルなビジュアルが信頼性を高め、進捗を効果的に伝える助けになります。',
          },
        ],
        faqItems: [
          {
            question: 'Veeso で投資家に印象を与えるピッチデックを作成できますか？',
            answer:
              'はい！ Veeso はコンテンツからプロフェッショナルなピッチデックスライドを作成することに優れています。スタートアップのストーリー、市場分析、プロダクト機能、財務予測を視覚的に魅力的なスライドに変換します。Veeso が適切な階層、チャート、グラフィックでコンテンツを自動構成し、ピッチをより引き込みやすく、記憶に残るものにします。',
          },
          {
            question: 'デザイナーなしで一貫したブランドアイデンティティを構築するには？',
            answer:
              'Veeso のブランドキット機能では、ブランドカラー、フォント、ビジュアルスタイルを一度設定するだけです。すべてのデザインが自動的にこれらのガイドラインに従い、SNS、プレゼンテーション、マーケティング素材などで一貫したブランドアイデンティティを確保します。デザインチームを雇うことなく、初日からプロフェッショナルなブランドプレゼンスを確立できます。',
          },
          {
            question: 'Veeso でプロダクトローンチ資料を作成できますか？',
            answer:
              'もちろんです！ Veeso でローンチ告知、プロダクトスクリーンショット、機能ハイライトグラフィック、デモビジュアル、ローンチキャンペーン素材を作成できます。プロフェッショナルなビジュアルがプロダクトローンチをよりインパクトがあり、シェアされやすいものにし、より多くの潜在顧客にリーチする助けになります。',
          },
          {
            question:
              '投資家アップデートや資金調達のコミュニケーションに Veeso はどう役立ちますか？',
            answer:
              'Veeso は進捗アップデート、指標、マイルストーンをプロフェッショナルなビジュアルレポートに変換します。投資家アップデートのスライド、成長チャート、マイルストーングラフィック、資金調達資料を作成し、進捗を明確に伝え、投資家の信頼を築けます。',
          },
          {
            question: 'スタートアップのプレゼンスを構築する SNS コンテンツを作成できますか？',
            answer:
              'はい！ Veeso ですべてのプラットフォーム向けに、一貫したプロフェッショナルな SNS コンテンツを作成できます。ブランドプレゼンスを構築する投稿、ストーリー、バナー、ヘッダーをデザインします。定期的でよくデザインされたコンテンツは信頼性を確立し、顧客、パートナー、人材を惹きつける助けになります。',
          },
          {
            question: 'アイデアから公開コンテンツまでどのくらい速くできますか？',
            answer:
              'Veeso なら、アイデアを数分で公開コンテンツに変換できます。デザイナーを待つことも、何度もやり取りすることも、代理店のスケジュールに合わせる必要もありません。このスピードは、タイミングと俊敏性が最も重要なスタートアップにとって不可欠です。',
          },
          {
            question: '採用活動用の資料を作成できますか？',
            answer:
              'はい！ Veeso でトップ人材を惹きつける求人投稿、採用グラフィック、雇用主ブランディング素材を作成できます。プロフェッショナルなビジュアルが、競争の激しい採用市場でスタートアップを際立たせ、企業文化を効果的に伝える助けになります。',
          },
          {
            question: 'Veeso はフリーランスデザイナーを雇うのとどう比較できますか？',
            answer:
              'Veeso は大幅なコスト削減とスピードの優位性を提供します。フリーランスデザイナーがプロジェクトごとに料金を請求し、数日から数週間かかるところを、Veeso は月額サブスクリプションで無制限のデザインを提供します。完全なコントロールを維持し、即座にイテレートし、スタートアップの成長に合わせてビジュアルコンテンツの制作をスケールできます。すべてデザインコストを増やすことなく実現できます。',
          },
          {
            question: 'パートナーシップや事業開発用の資料を作成できますか？',
            answer:
              'もちろんです！ Veeso でパートナーシップ提案書、ケーススタディ、パートナーシップ発表、事業開発素材を作成できます。プロフェッショナルなビジュアルがパートナーシップの機会をより魅力的にし、より速く契約をまとめる助けになります。',
          },
          {
            question: '顧客向けの資料に Veeso はどう役立ちますか？',
            answer:
              'Veeso で顧客オンボーディング資料、プロダクトドキュメント、機能ガイド、顧客コミュニケーション用グラフィックを作成できます。プロフェッショナルなビジュアルが顧客の理解を深め、サポート負担を軽減し、全体的なカスタマーエクスペリエンスを向上させます。',
          },
        ],
      },
      'for-creators': {
        title: 'クリエイター向け Veeso',
        subtitle: '際立つコンテンツを作成',
        description:
          'コンテンツのための魅力的なビジュアルをデザイン。YouTube サムネイル、Instagram 投稿、TikTok カバーなどに対応します。',
        heroTitle: 'クリックを増やし、エンゲージメントを高め、より速く成長',
        heroSubtitle:
          'クリックされるサムネイル、エンゲージメントを生む SNS 投稿、ブランドを構築するビジュアルを作成します。プロフェッショナルなデザインで、混雑したフィードの中で際立ち、オーディエンスをより速く成長させられます。',
        ctaText: '作成をはじめる',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso',
          description:
            'YouTube、Instagram、TikTok などの魅力的なビジュアルをデザイン。オーディエンスを成長させるコンテンツを作成できます。',
        },
        features: [
          {
            title: 'コンバージョンを生むサムネイル',
            description:
              'スクロールを止め、クリックを促す YouTube サムネイルをデザインします。複数のバリエーションを素早くテストし、オーディエンスに響くものを見つけられます。クリック率の向上はより多くの視聴回数と、より速いチャンネル成長を意味します。',
          },
          {
            title: '一貫したブランドアイデンティティ',
            description:
              'すべてのコンテンツで認識されやすいビジュアルスタイルを構築します。一貫した色、フォント、デザイン要素により、オーディエンスがあなたのコンテンツを瞬時に認識でき、ブランドロイヤリティと想起を構築できます。',
          },
          {
            title: 'マルチプラットフォームコンテンツ',
            description:
              'Instagram 投稿、TikTok カバー、YouTube サムネイル、Twitter ヘッダーなど、あらゆるプラットフォーム向けに最適化されたビジュアルを作成します。1 つのコンテンツアイデアから、リーチを最大化する複数のプラットフォーム対応デザインを生み出せます。',
          },
          {
            title: 'エンゲージメントを生むビジュアル',
            description:
              'いいね、シェア、コメントを促すビジュアルをデザインします。明確なメッセージと魅力的なビジュアルを備えたよく作り込まれたグラフィックは、エンゲージメント率を高め、コンテンツがアルゴリズム上でよりよくパフォーマンスする助けになります。',
          },
        ],
        faqItems: [
          {
            question: 'Veeso でクリック率の高い YouTube サムネイルを作成できますか？',
            answer:
              'もちろんです！ Veeso はクリック率に最適化された目を引く YouTube サムネイル作成をサポートします。複数のバリエーションを素早く生成して、オーディエンスに最も効果的なものをテストできます。明確なテキスト、魅力的なビジュアル、適切なコントラストを備えたよくデザインされたサムネイルは、クリック率を大幅に向上させ、より多くの視聴回数とより速いチャンネル成長につながります。',
          },
          {
            question: 'すべてのコンテンツで一貫したビジュアルスタイルを維持するには？',
            answer:
              'Veeso のブランドキット機能では、シグネチャーカラー、フォント、ビジュアルスタイルを設定できます。一度設定すれば、すべてのデザインが自動的にこれらのガイドラインに従い、YouTube サムネイル、Instagram 投稿、TikTok カバーなどのコンテンツで一貫したブランドアイデンティティを確保します。この一貫性により、オーディエンスがあなたのコンテンツを瞬時に認識でき、ブランドロイヤリティを構築できます。',
          },
          {
            question: '同じアイデアから複数プラットフォーム向けのコンテンツを作成できますか？',
            answer:
              'はい！ Veeso では同じコンテンツからプラットフォーム最適化されたデザインを作成できます。1 つの動画アイデアを、YouTube サムネイル、Instagram 投稿、TikTok カバー、Twitter ヘッダーに変換でき、すべて各プラットフォーム向けに正しくフォーマットされます。これにより、ゼロからすべて作成することなく、コンテンツのリーチを最大化できます。',
          },
          {
            question: 'Veeso はエンゲージメント率の改善にどう役立ちますか？',
            answer:
              'Veeso は明確なメッセージ、魅力的な構図、適切な視覚的階層を備えたビジュアルを作成し、いいね、コメント、シェアを促します。よくデザインされたグラフィックはアルゴリズム上でよりよくパフォーマンスし、より多くのオーガニックリーチとより速いオーディエンス成長につながります。',
          },
          {
            question: 'Veeso で Instagram のカルーセル投稿を作成できますか？',
            answer:
              'はい！ Veeso は複数スライドの Instagram カルーセル投稿の作成に優れています。各スライドのコンテンツを入力するだけで、Veeso が一貫したスタイリングのまとまりのあるカルーセルデザインを生成します。カルーセル投稿は通常、単一画像よりも高いエンゲージメント率を獲得し、より速い成長を助けます。',
          },
          {
            question: '投稿スケジュールに合わせてどのくらい速くコンテンツを作成できますか？',
            answer:
              'Veeso なら、数分で複数のコンテンツを作成できます。このスピードは、一貫した投稿スケジュールを維持する必要があるクリエイターにとって不可欠です。サムネイル、SNS 投稿、その他のビジュアルをあらかじめまとめて作成し、投稿の機会を逃さないようにできます。',
          },
          {
            question: 'TikTok カバーや動画サムネイルを作成できますか？',
            answer:
              'もちろんです！ Veeso で混雑したフィードの中で際立つ TikTok カバー、動画サムネイル、ストーリーグラフィックを作成できます。プロフェッショナルなビジュアルが動画の視聴回数を増やし、チャンネル全体のパフォーマンスを向上させる助けになります。',
          },
          {
            question: 'コンテンツの A/B テストに Veeso はどう役立ちますか？',
            answer:
              'Veeso では複数のデザインバリエーションを素早く簡単に作成できます。異なるサムネイルスタイル、配色、テキスト処理、レイアウトをテストし、オーディエンスに最も響くものを確認できます。このデータドリブンなアプローチがコンテンツ戦略の最適化と時間経過によるパフォーマンス向上を助けます。',
          },
          {
            question: '定期的なコンテンツ用のブランド化されたテンプレートを作成できますか？',
            answer:
              'はい！ Veeso でブランドスタイルを確立すれば、同じビジュアル言語に従った新しいコンテンツを素早く作成できます。この一貫性により、時間を節約しつつ、すべてのコンテンツがシグネチャーの見た目と印象を維持できます。',
          },
          {
            question: 'Veeso でオーディエンスをより速く成長させるには？',
            answer:
              'プロフェッショナルなビジュアルが混雑したフィードの中でコンテンツを際立たせ、高いクリック率、より良いエンゲージメント、アルゴリズム上のパフォーマンス向上につながります。コンテンツがプロフェッショナルで一貫した見た目のとき、オーディエンスがフォロー、シェアし、ブランドを覚えてくれる可能性が高まり、これらすべてが成長を加速させます。',
          },
        ],
      },
      'for-startups': {
        title: 'スタートアップ向け Veeso',
        subtitle: 'チームを拡大せずにデザインをスケール',
        description:
          'スタートアップのスピードで、プロフェッショナルなマーケティング素材、プロダクトビジュアル、ブランドアセットを作成できます。',
        heroTitle: 'より速くローンチし、よりスマートにスケールし、限界なく成長',
        heroSubtitle:
          'デザイナーを雇うことなく無制限のプロフェッショナルなデザインを作成できます。プロダクトのスケールと同じ速さでビジュアルコンテンツの制作をスケールさせ、ブランドの一貫性とプロフェッショナルな品質を維持できます。',
        ctaText: 'はじめる',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso',
          description:
            'スタートアップのスピードでプロフェッショナルなマーケティング素材とプロダクトビジュアルを作成。チームを拡大せずにデザインをスケールできます。',
        },
        features: [
          {
            title: 'ローンチ即対応のマーケティング素材',
            description:
              'コンバージョンを生むランディングページ、広告クリエイティブ、メールキャンペーン、SNS コンテンツを作成します。プロフェッショナルなビジュアルにより、初日から確立されたブランドと競争できます。',
          },
          {
            title: '売れるプロダクトビジュアル',
            description:
              'プロダクトのスクリーンショット、機能ハイライト、デモグラフィック、ショーケースビジュアルをデザインし、バリュープロポジションを明確に伝えます。優れたビジュアルが潜在顧客にプロダクトを理解させ、欲しいと思わせる助けになります。',
          },
          {
            title: '大規模でも一貫したブランド',
            description:
              '成長に合わせて、すべてのタッチポイントでプロフェッショナルなブランドアイデンティティを維持します。ブランドキットにより、すべてのデザインがガイドラインに自動で従い、手動チェックなしに信頼と認知を構築できます。',
          },
          {
            title: 'コスト効率の高いデザインオペレーション',
            description:
              'デザイナーを雇ったり代理店と仕事をしたりする必要をなくします。わずかなコストで無制限のデザインを作成でき、プロダクト開発と成長により多く投資できるようになります。',
          },
        ],
        faqItems: [
          {
            question:
              'スタートアップが確立されたブランドとビジュアル面で競争するために Veeso はどう役立ちますか？',
            answer:
              'Veeso はスタートアップが確立されたブランドの品質に匹敵する、あるいは上回るプロフェッショナルで洗練されたビジュアルを作成することを可能にします。一貫したブランディング、高品質なデザイン、適切な視覚的階層により、スタートアップはデザイン代理店を雇うコストなしに、初日から信頼と信用を構築できます。',
          },
          {
            question: 'プロダクトローンチに必要なすべてのマーケティング素材を作成できますか？',
            answer:
              'はい！ Veeso でローンチに必要なすべて、つまりランディングページ用グラフィック、広告クリエイティブ、メールキャンペーン用ビジュアル、SNS コンテンツ、プレスリリース用グラフィック、プロダクトショーケース素材を作成できます。すべてのデザインがブランドの一貫性とプロフェッショナルな品質を維持し、ローンチを洗練された信頼性のあるものに見せられます。',
          },
          {
            question:
              '成長に合わせてデザインオペレーションをスケールするのに Veeso はどう役立ちますか？',
            answer:
              'Veeso はスタートアップとともにスケールします。追加のデザイナーを雇ったりコストを増やしたりすることなく、無制限のデザインを作成できます。プロダクトが成長し、より多くのマーケティング素材、プロダクトビジュアル、ブランドアセットが必要になっても、Veeso ならデザインチームや予算をスケールさせることなく即座に制作できます。',
          },
          {
            question: 'プロダクトを紹介するスクリーンショットや機能グラフィックを作成できますか？',
            answer:
              'もちろんです！ Veeso でプロフェッショナルなプロダクトスクリーンショット、機能ハイライトグラフィック、デモビジュアル、比較表を作成できます。よくデザインされたプロダクトビジュアルが、潜在顧客にバリュープロポジションを素早く理解させ、購入決定をより速く行ってもらう助けになります。',
          },
          {
            question: 'フリーランスデザイナーを雇うのと Veeso はどう比較できますか？',
            answer:
              'Veeso には大きな利点があります：プロジェクト単位の料金ではなく月額固定のコストで無制限のデザイン、数日〜数週間の待ち時間ではなく即時の納品、何度ものやり取りではなく完全なクリエイティブコントロール、手動チェックではなく一貫したブランド適用。スタートアップにとってこれは、より速いイテレーション、低いコスト、より高いスケーラビリティを意味します。',
          },
          {
            question: 'スケールしながらすべての素材でブランドの一貫性を維持できますか？',
            answer:
              'はい！ Veeso のブランドキット機能により、すべてのデザインが自動的にブランドガイドラインに従います。マーケティングキャンペーン、プロダクトビジュアル、プレゼンテーション、SNS コンテンツなど、より多くの素材を作成しても、すべてが手動レビューなしで一貫した色、フォント、ビジュアルスタイルを維持します。',
          },
          {
            question: '時間制約のあるキャンペーン用の素材をどのくらい速く作成できますか？',
            answer:
              'Veeso なら、キャンペーンのアイデアから公開ビジュアルまで数分で完了します。市場機会が速く動くスタートアップにとって、このスピードは不可欠です。デザイナーを待つことも、代理店のスケジュールに合わせる必要もなく、即時にプロフェッショナルな結果を得られます。',
          },
          {
            question: '投資家向け資料や資金調達用ビジュアルを作成できますか？',
            answer:
              'はい！ Veeso でピッチデック、投資家アップデート、成長チャート、マイルストーングラフィック、資金調達資料を作成できます。プロフェッショナルなビジュアルが進捗を明確に伝え、資金調達の成功に不可欠な投資家の信頼を築く助けになります。',
          },
          {
            question: '顧客獲得用の素材に Veeso はどう役立ちますか？',
            answer:
              'Veeso では顧客獲得を促進する、コンバージョン最適化されたランディングページ、広告クリエイティブ、メールキャンペーン、SNS コンテンツを作成できます。プロフェッショナルなビジュアルがクリック率、エンゲージメント、コンバージョン率を向上させ、成長指標に直接インパクトを与えます。',
          },
          {
            question: 'パートナーシップや事業開発用の素材を作成できますか？',
            answer:
              'もちろんです！ Veeso でパートナーシップ提案書、ケーススタディ、統合グラフィック、事業開発素材を作成できます。プロフェッショナルなビジュアルがパートナーシップの機会をより魅力的にし、より速く契約をまとめ、スタートアップの成長を加速する助けになります。',
          },
        ],
      },
      default: {
        title: 'Veeso ソリューション',
        subtitle: 'Veeso がどのようにあなたを支援できるかをご紹介します',
        description: 'ニーズに最適なソリューションを見つけましょう。',
        heroTitle: 'すべてのチームのためのソリューション',
        heroSubtitle: 'Veeso がどのように魅力的なビジュアル作成をサポートできるかをご覧ください。',
        ctaText: 'はじめる',
        ctaLink: '/signup',
        meta: {
          title: 'Veeso ソリューション',
          description: 'チーム向けの Veeso ソリューションをご紹介します。',
        },
        features: [],
        faqItems: [],
      },
    },
  },
};
